<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aXoHYV/tc-custom/9781035855117.jpg?1718106016517" alt="This image is the cover for the book Whisper"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Whisper
      </h1>
      <p class="bookDescription body article font2">
        <p>Britney is a young, extremely malnourished child, who comes from a poor family with an abusive father. Her mother does everything she can to protect her daughter from her husband, receiving the brunt of the aggressive beatings herself. The girl barely speaks, afraid of being overheard by the wrong person, and the only words she knows are the few repeated words her mother uses to calm her after a fight. A total of three words in all, namely – Whisper, Britney, and Ma. There is a very private, sheltered spot in the nearby forest which Britney uses as a place to hide away if ever her mother has to spend the day walking into the nearest town to purchase supplies or to trade goods. They have discreet, non-verbal signals which they use to keep the area hidden and make sure that Britney is secure (far away from Pa’s prying eyes). On one such day, Britney hears unusual soundsand is terrified that her father has found out about their system, but the surprise turns out to be just a lonesome little puppy. The girl quickly becomes friends with the stray, instantly joining forces in their solitude, only ever meeting in the secret place where they share such a deeply silent, unspoken bond. This continues until Ma helps her only child run away for good, tearfully leaving Britney to fend for herself in the best way she knows how. The adoring puppy (promptly being referred to as Whisper) unexpectedly follows the girl, and together they set off on a journey that will forever change their lives…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alison Bellringer
      </h2>
      
      <p class="authorDescription body article">Alison Bellringer has been writing short stories to share with friends and family for many years and always enjoys exploring her creativity when putting pen to paper. She is excited to have the opportunity to share her love of writing with others. Alison loves spending time with her pet dog, a Labrador x Huntaway called Smoky, teaching her tricks and taking her for walks. She lives in a small town in New Zealand near many beautiful parks and beaches. Alison has been playing trombone since about 2010, and euphonium from mid-2019, and always likes getting together with a few friends to ‘make a joyful noise’. She also enjoys a bit of photography when she gets the chance, especially if it involves taking pictures of sunsets.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a7b0a1d